import React, { useState, useEffect } from "react";
import { Button, TextField, Box, Typography, Avatar } from "@mui/material";
import {
  API_edit_currency_rate,
  API_get_currency_rate,
  GG_AUTH_LINK,
} from "../utils/http";
import GoogleIcon from "@mui/icons-material/Google";

const sxTextField = {
  m: 0.5,
  width: "100%",
  maxWidth: 400,
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: 13,
  },
  "& .MuiInputLabel-root": {
    fontSize: 13,
  },
};

const AdminRate = ({}) => {
  const [data, set_data] = useState(null);
  const [showlogin, set_showlogin] = useState(false);

  async function GetData() {
    API_get_currency_rate((x) => {
      if (x.success) {
        x = x.data;

        if (x.email == null) {
          set_showlogin(true);
        }

        set_data(x);
      } else {
      }
    });
  }

  async function EditData() {
    await API_edit_currency_rate(data._id, data, (x) => {
      console.log(x);
    });
  }

  useEffect(() => {
    GetData();
  }, []);

  if (data == null) {
    return null;
  } else {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        <Typography sx={{ fontWeight: 600, fontSize: 16, color: "#333" }}>
          Admin Mail
        </Typography>
        {showlogin ? (
          <Button
            onClick={() => window.open(GG_AUTH_LINK, "_blank")}
            variant="contained"
            disableElevation
            startIcon={<GoogleIcon />}
            sx={{
              width: 250,
              borderRadius: "20px",
              textTransform: "none",
              fontWeight: 500,
              fontSize: 13,
            }}
          >
            Admin login Google
          </Button>
        ) : (
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
            <Avatar src={data.picture} sx={{ width: 48, height: 48 }} />
            <Box>
              <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
                {data.name}
              </Typography>
              <Typography sx={{ fontSize: 13, color: "#666" }}>
                {data.email}
              </Typography>
            </Box>
          </Box>
        )}

        <Typography sx={{ fontWeight: 600, fontSize: 16, color: "#333", mt: 1 }}>
          Rate
        </Typography>
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          <TextField
            sx={sxTextField}
            size="small"
            id="rate AUD"
            label="Rate AUD"
            variant="outlined"
            value={data.currency_rate.AUD}
            onChange={(e) => {
              set_data({
                ...data,
                currency_rate: {
                  ...data.currency_rate,
                  AUD: e.target.value,
                },
              });
            }}
          />
          <TextField
            sx={sxTextField}
            size="small"
            id="rate USD"
            label="Rate USD"
            variant="outlined"
            value={data.currency_rate.USD}
            onChange={(e) => {
              set_data({
                ...data,
                currency_rate: {
                  ...data.currency_rate,
                  USD: e.target.value,
                },
              });
            }}
          />
        </Box>
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          <TextField
            sx={sxTextField}
            size="small"
            id="rate single"
            label="Rate Single"
            variant="outlined"
            value={data.customer_rate.single}
            onChange={(e) => {
              set_data({
                ...data,
                customer_rate: {
                  ...data.customer_rate,
                  single: e.target.value,
                },
              });
            }}
          />
          <TextField
            sx={sxTextField}
            size="small"
            id="rate double"
            label="Rate Double"
            variant="outlined"
            value={data.customer_rate.double}
            onChange={(e) => {
              set_data({
                ...data,
                customer_rate: {
                  ...data.customer_rate,
                  double: e.target.value,
                },
              });
            }}
          />
        </Box>

        <Button
          variant="contained"
          disableElevation
          sx={{
            width: "100%",
  maxWidth: 400,
            m: 0.5,
            borderRadius: "20px",
            textTransform: "none",
            fontWeight: 500,
            fontSize: 13,
          }}
          onClick={() => {
            console.log(data);
            EditData();
          }}
        >
          Save Rate
        </Button>
      </Box>
    );
  }
};

export { AdminRate };
